import { ridSegment } from '@krp/client-runtime'

/**
 * Адреса чтения чеков AQSI (`AqsiReceiptEndpoints`, срез C4a), через Gateway.
 * Литерал `/api/` законен только в файлах `api/urls.ts` (eslint). Rid — всегда
 * в пути; номер чека и кассы кодируются: это ввод, а не доверенный текст.
 */
const base = (resourceId: string) => `/api/aqsi/v1/resources/${ridSegment(resourceId)}/receipts`

export const AQSI_RECEIPT_URLS = {
  list: (resourceId: string) => base(resourceId),
  one: (resourceId: string, receiptId: string) => `${base(resourceId)}/${encodeURIComponent(receiptId)}`,
  registers: (resourceId: string) => `${base(resourceId)}/registers`,
  shifts: (resourceId: string, registerId: string) =>
    `${base(resourceId)}/registers/${encodeURIComponent(registerId)}/shifts`,
  // Итоги по тому же отбору, что и список.
  summary: (resourceId: string) => `${base(resourceId)}/summary`,
  journalStatus: (resourceId: string) => `${base(resourceId)}/journal/status`,
  journalSync: (resourceId: string) => `${base(resourceId)}/journal/sync`,
  // Смены, которые за период открывал или вёл текущий пользователь.
  myShifts: (resourceId: string) => `${base(resourceId)}/my-shifts`,
} as const
